import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { EventEmitter } from 'eventemitter3';

var TilePickManager = function (_EventEmitter) {
  _inherits(TilePickManager, _EventEmitter);

  var _super = _createSuper(TilePickManager);

  function TilePickManager(parent, rendererService, pickingService, children, layerService) {
    var _this;

    _classCallCheck(this, TilePickManager);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "isLastPicked", false);

    _defineProperty(_assertThisInitialized(_this), "rendererService", void 0);

    _defineProperty(_assertThisInitialized(_this), "pickingService", void 0);

    _defineProperty(_assertThisInitialized(_this), "layerService", void 0);

    _defineProperty(_assertThisInitialized(_this), "children", void 0);

    _defineProperty(_assertThisInitialized(_this), "parent", void 0);

    _this.parent = parent;
    _this.rendererService = rendererService;
    _this.pickingService = pickingService;
    _this.layerService = layerService;
    _this.children = children;
    return _this;
  }

  _createClass(TilePickManager, [{
    key: "normalRender",
    value: function normalRender(layers) {
      var _this2 = this;

      layers.filter(function (layer) {
        return layer.inited;
      }).filter(function (layer) {
        return layer.isVisible();
      }).map(function (layer) {
        layer.hooks.beforeRenderData.call();
        layer.hooks.beforeRender.call();

        if (layer.masks.length > 0) {
          _this2.rendererService.clear({
            stencil: 0,
            depth: 1,
            framebuffer: null
          });

          layer.masks.map(function (m) {
            m.hooks.beforeRender.call();
            m.render();
            m.hooks.afterRender.call();
          });
        }

        layer.render();
        layer.hooks.afterRender.call();
      });
    }
  }, {
    key: "pickRender",
    value: function pickRender(layers, target) {
      var _this3 = this;

      if (this.parent.type === 'RasterLayer') {
        this.renderMask(this.parent);
      }

      var isPicked = layers.filter(function (layer) {
        return _this3.parent.needPick(target.type) && layer.inited && layer.isVisible();
      }).some(function (layer) {
        layer.hooks.beforePickingEncode.call();

        if (layer.masks.length > 0) {
          _this3.rendererService.clear({
            stencil: 0,
            depth: 1,
            framebuffer: null
          });

          layer.masks.map(function (m) {
            m.hooks.beforeRender.call();
            m.render();
            m.hooks.afterRender.call();
          });
        }

        layer.renderModels(true);
        layer.hooks.afterPickingEncode.call();

        var layerPicked = _this3.pickingService.pickFromPickingFBO(layer, target);

        if (layerPicked && _this3.parent.type !== 'RasterLayer') {
          _this3.emit('pick', {
            type: target.type,
            pickedColors: _this3.pickingService.pickedColors,
            layer: layer
          });

          _this3.pickingService.pickedTileLayers = [_this3.parent];
        }

        return layerPicked;
      });

      if (this.parent.type !== 'RasterLayer' && !isPicked && this.isLastPicked && target.type !== 'click') {
        this.pickingService.pickedTileLayers = [];
        this.emit('unpick', {});
        this.beforeHighlight([0, 0, 0]);
      }

      this.isLastPicked = isPicked;
      return isPicked;
    }
  }, {
    key: "clearPick",
    value: function clearPick() {
      this.children.filter(function (child) {
        return child.inited && child.isVisible();
      }).map(function (layer) {
        layer.hooks.beforeSelect.call([0, 0, 0]);
      });
      this.pickingService.pickedTileLayers = [];
    }
  }, {
    key: "beforeHighlight",
    value: function beforeHighlight(pickedColors) {
      this.children.filter(function (child) {
        return child.inited && child.isVisible();
      }).map(function (child) {
        child.hooks.beforeHighlight.call(pickedColors);
      });
    }
  }, {
    key: "beforeSelect",
    value: function beforeSelect(pickedColors) {
      this.children.filter(function (child) {
        return child.inited && child.isVisible();
      }).map(function (layer) {
        layer.hooks.beforeSelect.call(pickedColors);
      });
    }
  }, {
    key: "renderMask",
    value: function renderMask(layer) {
      if (layer.inited && layer.isVisible()) {
        layer.hooks.beforeRender.call();

        if (layer.masks.length > 0) {
          this.rendererService.clear({
            stencil: 0,
            depth: 1,
            framebuffer: null
          });
          layer.masks.map(function (m) {
            m.hooks.beforeRender.call();
            m.render();
            m.hooks.afterRender.call();
          });
        }

        layer.hooks.afterRender.call();
      }
    }
  }]);

  return TilePickManager;
}(EventEmitter);

export { TilePickManager as default };
//# sourceMappingURL=tilePickerManager.js.map